import { resolveMenuItemAttributes } from "@/storyblok/resolvers";
import { FooterBlockData } from "@/storyblok/schemas";
import { makeEditable } from "@/storyblok/visual-editor";
import Link from "next/link";

export default function Footer({ data }: { data: FooterBlockData }) {
  const columns = [1, 2, 3, 4] as const;
  const currentYear = new Date().getFullYear();
  return (
    <footer
      style={{
        marginTop: "0px",
      }}
      {...makeEditable(data)}
    >
      {data.logo && (
        <div className="container container-footer-logo">
          <div className="col">
            <img className="logo" src={data.logo.filename} alt="Client Logo" />
          </div>
        </div>
      )}
      <div className="container">
        {columns.map(
          (column) =>
            data[`column${column}_title`] && (
              <div className="col" key={column}>
                <h5>{data[`column${column}_title`]}</h5>
                <details open={true}>
                  <summary>
                    <b></b>
                    <b></b>
                  </summary>
                  <ul>
                    {data[`column${column}_items`].map((i) => (
                      <li key={i._uid} {...makeEditable(i)}>
                        <Link {...resolveMenuItemAttributes(i)}>{i.label}</Link>
                      </li>
                    ))}
                  </ul>
                </details>
              </div>
            )
        )}
      </div>
      <div className="socket">
        <div className="container">
          <div className="col">
            <span>powered&nbsp;by</span>
            <img
              className="logo"
              src="/assets/images/compagnon_logo_white.svg"
              alt="Compagnon"
            />
          </div>
          <div className="col">
            <span>
              &copy; {currentYear} <span>&nbsp;|&nbsp;</span> {data.copyright}
            </span>
          </div>
          <div className="col">
            <ul>
              {data.socket_items.map((i) => (
                <li key={i._uid} {...makeEditable(i)}>
                  <Link {...resolveMenuItemAttributes(i)}>{i.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="compagnon_tulip">
        <span></span>
        <span></span>
      </div>
      <a className="compagnon_brand_icon" href="https://www.compagnon.com">
        <img
          src="/assets/images/compagnon_brand_icon.svg"
          alt="Compagnon Brand Icon"
        />
      </a>
    </footer>
  );
}
